import { mergeClasses } from '@/utils';

import { AlertTriangleIcon, CheckCircleIcon, ClockRewindIcon, ScanIcon } from '@/assets/icons';
import { IBadge } from '@/components/common';

import { LinkStatus } from '@/features/regulatory-intake/enums';

export const getLinkStatusLabel = (status: LinkStatus): string => {
  switch (status) {
    case LinkStatus.Resolved:
      return 'Resolved';
    case LinkStatus.Pending:
      return 'Pending';
    case LinkStatus.CaptchaCheck:
    case LinkStatus.Downloading:
      return 'CAPTCHA Check';
    case LinkStatus.Attention:
      return 'Attention';
  }
};

export const getLinkStatusVariant = (status: LinkStatus): IBadge['variant'] => {
  switch (status) {
    case LinkStatus.Resolved:
      return 'green';
    case LinkStatus.Attention:
      return 'red';
    default:
      return 'red';
  }
};

export const getLinkStatusIcon = (status: LinkStatus, className?: string): React.ReactNode => {
  switch (status) {
    case LinkStatus.Resolved:
      return (
        <CheckCircleIcon
          className={mergeClasses('shrink-0 size-4 text-semantic-success-base', className)}
        />
      );
    case LinkStatus.Pending:
      return (
        <ClockRewindIcon
          className={mergeClasses('shrink-0 size-4 text-semantic-warning-base', className)}
        />
      );
    case LinkStatus.CaptchaCheck:
    case LinkStatus.Downloading:
      return (
        <ScanIcon
          className={mergeClasses('shrink-0 size-4 text-semantic-warning-base', className)}
        />
      );
    case LinkStatus.Attention:
      return (
        <AlertTriangleIcon
          className={mergeClasses('shrink-0 size-4 text-semantic-error-base', className)}
        />
      );
  }
};
